<template>
  <div>
    <a-modal
      :visible="visible"
      title="新增生产计划"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      @cancel="cancel"
      @ok="confirm"
    >
      <div>
        <a-form-model ref="form" :model="dataForm" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="number" label="生产工单号">
            <a-input v-model="dataForm.number" />
          </a-form-model-item>
          <a-form-model-item prop="type" label="类型">
            <a-select v-model="dataForm.type" style="width: 100%">
              <a-select-option value="order">按订单生产</a-select-option>
              <a-select-option value="inventory">按库存生产</a-select-option>
              <a-select-option value="internal">自产</a-select-option>
              <a-select-option value="purchase">采购</a-select-option>
              <a-select-option value="outsourcing">外协</a-select-option>
              <a-select-option value="supply_outsourcing">供料外协</a-select-option>
              <a-select-option value="client_supply_outsourcing">客供料外协</a-select-option>
              <a-select-option value="client_supply">客供</a-select-option>
              <a-select-option value="client_material">客供料</a-select-option>
              <a-select-option value="client_part">客供件</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="goods" label="物料">
            <GoodsSelect v-model="dataForm.goods" :defaultItem="{ id: dataForm.goods, name: dataForm.goods_name }" />
          </a-form-model-item>
          <a-form-model-item prop="total_quantity" label="生产数量">
            <a-input-number v-model="dataForm.total_quantity" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input v-model="dataForm.remark" />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { productionOrderCreate } from "@/api/production";

export default {
  components: {
    GoodsSelect: () => import("@/components/GoodsSelect/index"),
  },
  props: ["visible", "productionOrderItem"],
  model: { prop: "visible", event: "cancel" },
  data() {
    return {
      rules: {
        number: [
          { required: true, message: "请输入编号", trigger: "change" },
          { max: 32, message: "超出最大长度 (32)", trigger: "change" },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        goods: [{ required: true, message: "请选择生产物料", trigger: "change" }],
        total_quantity: [{ required: true, message: "请输入生产数量", trigger: "change" }],
      },
      confirmLoading: false,
      dataForm: {},
    };
  },
  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const dataForm = {
            ...this.dataForm,
            parent_production_order: this.productionOrderItem.parent_production_order,
          };

          productionOrderCreate(dataForm)
            .then((data) => {
              this.$message.success("新增成功");
              this.$emit("create", data);
              this.cancel();
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      this.$refs.form.resetFields();
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.dataForm = {
          number: `${this.productionOrderItem.number}-1`,
          goods: this.productionOrderItem.goods,
          goods_name: this.productionOrderItem.goods_name,
          type: this.productionOrderItem.type,
          total_quantity: 1,
          remark: undefined,
          company_order_number: this.productionOrderItem.company_order_number,
          client_name: this.productionOrderItem.client_name,
          document_number: this.productionOrderItem.document_number,
          project_code: this.productionOrderItem.project_code,
          delivery_date: this.productionOrderItem.delivery_date,
          file_number: this.productionOrderItem.file_number,
          project_name: this.productionOrderItem.project_name,
          version_number: this.productionOrderItem.version_number,
          parent_production_order: this.productionOrderItem.parent_production_order,
        };
      }
    },
  },
};
</script>

<style scoped></style>
